export default __webpack_public_path__ + "static/media/streetSKILLS-female-coach-sc-2.3a926581.jpg";